import { DateObject } from '../../reusables/date-object';

/**
 * Blueprint for the tickets part of ticketing object.
 */
export class TicketingTickets {
  public blockName: string;
  public row: number;
  public seat: number;
  public tribune: string;
  public barcode: string;
  public ticketId: string;
  public invoiceId: string;
  public reservationId: string;
  public cancellationId: string;
  public price: string;
  public status: string;
  public type: string;
  public priceCategoryName: string;
  public priceReductionName: string;
  public ticketAccesses: Array<TicketingTicketAccess> = [];

  constructor(data?: any) {
    this.blockName = data.blockName;
    this.row = data.row;
    this.seat = data.seat;
    this.tribune = data.tribune;
    this.barcode = data.barcode;
    this.ticketId = data.ticketId;
    this.invoiceId = data.invoiceId;
    this.reservationId = data.reservationId;
    this.cancellationId = data.cancellationId;
    this.price = data.price;
    this.status = data.status;
    this.type = data.type;
    this.priceCategoryName = data.priceCategoryName;
    this.priceReductionName = data.priceReductionName;
    for (const ticketAccess of data.ticketAccesses) {
      this.ticketAccesses.push(new TicketingTicketAccess(ticketAccess));
    }
  }

  get displayType(): string {
    return this.priceReductionName !== null ? this.priceReductionName : this.priceCategoryName;
  }
}

export class TicketingTicketAccess {
  public area: string;
  public barcode: string;
  public checkpoint: string;
  public scannedAt: DateObject;
  public turnstile: string;

  constructor(data?: any) {
    this.area = data.area;
    this.barcode = data.barcode;
    this.checkpoint = data.checkpoint;
    this.scannedAt = new DateObject(data.scannedAt, 'dd.MM.yyyy HH:mm');
    this.turnstile = data.turnstile;
  }
}
